// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"588":"56a6368f","726":"f93cb2d2","774":"506bb7b9","977":"a8f2cd75"}[chunkId] + ".css";
};